import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { AuthServiceService } from "../../shareModule/services/auth-service.service";
import { LocalServiceService } from "../../shareModule/services/local-service.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
    @ViewChild('detailPost', { static: true }) detailPost: TemplateRef<any>;

    constructor(
        private router: Router,
        private local: LocalServiceService,
        private auth: AuthServiceService,
        private toastr: ToastrService,
        private modalService: NgbModal,
        private clipboard: Clipboard,
        private route: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private formBuilder: FormBuilder) { }


    private modalRef: any;
    isLogin: any = 0;
    isLoading: boolean = false;
    appUserId: any;

    ngOnInit() {
        const getUser = this.local.getUser();

        if (getUser) {
            this.appUserId = getUser.id;
        }
    }

    ngOnDestroy(): void {
        // Clear all intervals
    }

}